<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="32"
    height="32"
    viewBox="0 0 32 32"
    fill="none"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M4.00008 10.7656V17.7738L12.1903 21.6368L20.5662 12.8243L15.0746 2.81842C14.8975 2.87829 14.7249 2.95535 14.5595 3.05042L5.44075 8.28479C4.54928 8.79639 4.00008 9.74212 4.00008 10.7656Z"
      fill="#57B7DD"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M12.1902 21.6368L22.0656 26.2947L26.5472 23.7221L20.566 12.8243L12.1902 21.6368Z"
      fill="#F99132"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M25.4733 7.66134L17.4406 3.05041C16.7146 2.63361 15.8514 2.55641 15.0745 2.81854L20.5661 12.8244L25.4733 7.66134Z"
      fill="#A98BBC"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M26.5474 23.7221L26.5596 23.715C27.451 23.2033 28.0002 22.2577 28.0002 21.2344V10.7656C28.0002 9.74211 27.451 8.79651 26.5596 8.28478L25.4736 7.66132L20.5663 12.8244L26.5474 23.7221Z"
      fill="#FF6D56"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M4.00008 17.7739V21.2344C4.00008 22.2577 4.54928 23.2035 5.44075 23.7152L8.52968 25.4883L12.1903 21.6369L4.00008 17.7739Z"
      fill="#8AC539"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M8.52959 25.4882L14.5595 28.9496C15.4509 29.4612 16.5492 29.4612 17.4407 28.9496L22.0657 26.2946L12.1903 21.6368L8.52959 25.4882Z"
      fill="#FFBE0A"
    />
  </svg>
</template>
